import dayjs from "dayjs";
import { MessageBox } from "element-ui";
import i18n from "@/i18n";

export function isFirefox() {
  return window.navigator.userAgent?.toLowerCase().indexOf("firefox") > -1;
}

export function getServiceStr(key: string, list: any[]): string {
  const node = list.find((el) => el.key === key);
  const value = "";
  return value.replace("[", "").replace("]", "");
}

// 转换对应位数的数字
export function transformNumber(number: any, length: number) {
  let currentLength = length - ("" + number).length;
  return (
    (currentLength > 0 ? new Array(++currentLength).join("0") : "") + number
  );
}

// 利用数组里面 propertyName 属性对数字进行降序排序，对象中加入index可保持相同值顺序不变
export function numberCompare(propertyName: string) {
  return function (obj1: any, obj2: any) {
    const value1 = Number(obj1[propertyName]);
    const value2 = Number(obj2[propertyName]);
    if (value1 < value2) {
      return 1;
    } else if (value1 > value2) {
      return -1;
    }
    return obj1.index - obj2.index;
  };
}

// 格式化获取当前日期
export function floorDate(date: Date): any {
  const newDate = new Date();
  newDate.setFullYear(date.getFullYear());
  newDate.setMonth(date.getMonth());
  newDate.setDate(date.getDate());
  newDate.setHours(0);
  newDate.setMinutes(0);
  newDate.setSeconds(0);
  newDate.setMilliseconds(0);
  return newDate;
}

const ONE_DAY = 24 * 3600 * 1000;
interface dateItem {
  weekDay: any;
  month: any;
  day: string;
  year: string;
  timestamp: string;
}

export function getWeekdayMultiLang(weekDay: number) {
  switch (weekDay) {
    case 1:
      return i18n.t("Monday");
    case 2:
      return i18n.t("Tuesday");
    case 3:
      return i18n.t("Wednesday");
    case 4:
      return i18n.t("Thursday");
    case 5:
      return i18n.t("Friday");
    case 6:
      return i18n.t("Saturday");
    case 0:
      return i18n.t("Sunday");
  }
}
// 定义多语言月份列表
export function getMonthMultiLang(month: number) {
  switch (month) {
    case 0:
      return i18n.t("January");
    case 1:
      return i18n.t("February");
    case 2:
      return i18n.t("March");
    case 3:
      return i18n.t("April");
    case 4:
      return i18n.t("May");
    case 5:
      return i18n.t("June");
    case 6:
      return i18n.t("July");
    case 7:
      return i18n.t("August");
    case 8:
      return i18n.t("September");
    case 9:
      return i18n.t("October");
    case 10:
      return i18n.t("November");
    case 11:
      return i18n.t("December");
  }
}

export function generateDateList(
  today: Date,
  pastCount: number,
  futureCount: number
): dateItem[] {
  // 生成日期列表
  const dates: any[] = new Array(pastCount + futureCount + 1).fill(0);
  const dateList: dateItem[] = [];
  dates.forEach((el, index) => {
    if (index < pastCount) {
      el = new Date(today.getTime() - ONE_DAY * (pastCount - index));
    } else if (index === pastCount) {
      el = new Date(today.getTime());
    } else {
      el = new Date(today.getTime() + ONE_DAY * (index - pastCount));
    }
    const tempList = el.toDateString().split(" ");
    dateList.push({
      weekDay: getWeekdayMultiLang(el.getDay()),
      month: getMonthMultiLang(el.getMonth()),
      day: tempList[2],
      year: tempList[3],
      timestamp: el.getTime(),
    });
  });
  return dateList;
}

export function formatTime(time: number): string {
  return dayjs(time).format("HH:mm");
}

export function isSameDate(date1: Date, date2: Date): boolean {
  return (
    date1.getFullYear() == date2.getFullYear() &&
    date1.getMonth() == date2.getMonth() &&
    date1.getDate() == date2.getDate()
  );
}

export function isToday(date: any): boolean {
  return isSameDate(new Date(), new Date(date));
}

// 根据宽高比例、图片宽度获取图片高度
export function getImgHeight(width: any, WidthHeightRatio: any) {
  const widthScale = WidthHeightRatio.slice(0, WidthHeightRatio.indexOf(":"));
  const heightScale = WidthHeightRatio.slice(WidthHeightRatio.indexOf(":") + 1);
  return (Number(width) * Number(heightScale)) / Number(widthScale);
}

/**
 * 是否是dev环境
 */
export const isDev = process.env.NODE_ENV === "development";

// 根据时间戳计算距离当前时间相差的时间
export function getHourUtilTimestamp(timestamp: any) {
  const currentTime = new Date().getTime();
  const hours = timestamp - currentTime;
  if (hours > 0) return (hours / (60 * 60 * 1000)).toFixed(0);
  return 0;
}

/**
 * 封装全局弹窗
 * @param messageInfo 消息配置项内容
 *  content 内容
 *  title 标题
 *  confirmButtonText 确认按钮内容
 * @returns promise
 */

export async function _confirm(messageInfo: any) {
  const _title = i18n.t("notice") as string;
  await MessageBox.confirm(messageInfo?.content, {
    closeOnClickModal: false,
    dangerouslyUseHTMLString: true,
    customClass: "__global_confirm",
    confirmButtonText: messageInfo?.confirmButtonText,
    showCancelButton: messageInfo?.showCancelButton || false,
    title: messageInfo?.title || _title,
    center: true,
    showClose: false,
  });
}
window._confirm = _confirm;

// 根据站内信时间戳生成需要的时间格式
export function formatNotificationTime(timestamp: number) {
  const updateTime = new Date(timestamp * 1000);
  return dayjs(updateTime).format("HH:mm DD-MM-YYYY");
}

// 根据时间戳生成需要的时间格式
export function formatTimeToDate(timestamp: number) {
  const updateTime = new Date(timestamp);
  return dayjs(updateTime).format("YYYY-MM-DD");
}

/**
 * @description 获取浏览器时区
 */
export function getZone(): number {
  const zone = 0 - new Date().getTimezoneOffset() / 60;
  return zone;
}

/**
 * @param e 随机数的位数,默认12位
 * @returns 返回{e}位的随机数
 */
export function randomString(e?: number): string {
  e = e || 12;
  const t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  const a = t.length;
  let n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
}

/**
 * 生成数据上报的sessionID
 */

// export function getSessionID() {
//   let cache_id = session.get(CACHE_SESSION);
//   if (!cache_id) {
//     const timestamp = new Date().getTime();
//     const random = randomString();
//     cache_id = `${timestamp}@${random}`;
//     session.set(CACHE_SESSION, cache_id);
//   }
//   return cache_id;
// }

/**
 * @description 获取浏览器本地语言
 * @returns 语言 string
 */
export function getLocalLang() {
  return window.navigator.language;
}

interface TypeUserAgent {
  os: string;
  browser: string;
  version: string;
  isSafari: boolean;
}

/**
 * 获取浏览器类型，版本号，操作系统
 */
export function UA() {
  const user_agent: TypeUserAgent = {
    os: "",
    browser: "",
    version: "",
    isSafari: false,
  };
  const ua = window.navigator.userAgent.toLowerCase();
  let os;
  if (ua.indexOf("windows") >= 0) {
    os = "window";
  } else if (ua.indexOf("mac") >= 0) {
    os = "mac";
  } else {
    os = "";
  }
  const re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
  const m = ua.match(re) as any;
  user_agent.browser = m[1].replace(/version/, "safari") || "";
  user_agent.version = m[2] || "";
  user_agent.os = os;
  user_agent.isSafari = user_agent.browser === "safari";
  return user_agent;
}

// 转换跑马灯字号
export function getMarqueeFontSize(fontSize: number) {
  let size = 13;
  switch (fontSize) {
    case 22:
      size = 13;
      break;
    case 25:
      size = 15;
      break;
    case 28:
      size = 17;
      break;
  }
  return size;
}

/**
 *
 * @param name url
 * @returns null / str
 */
export const getParam = (name: string, str: string) => {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = str.split("?")[1].match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null; //返回参数值
};

// 获取非 0 开头的 10 位随机数字
export function getRandomNumber10() {
  let randomNumber = "";
  // 生成第一位(1-9)
  const firstDigit = Math.floor(Math.random() * 9) + 1;
  // 生成剩余9位(0-9)
  let restDigits = "";
  for (let i = 0; i < 9; i++) {
    restDigits += Math.floor(Math.random() * 10);
  }
  randomNumber = firstDigit + restDigits;
  return randomNumber;
}
